/**
 * FIXME: Cannot import child BFG's DTMHandler class because Webpack gets in crazy
 * for a reason that I do not understand. We still have access to the singleton's
 * `cleanDataLayerSections()` method of the child class so let's keep it that way...
 */
const SuperDTMRule = require('dgad-analytics-bundle/lib/modules/dgad-analytics/src/adobe/DTMRule.class')
const SuperDTMHandler = require('dgad-analytics-bundle/lib/modules/dgad-analytics/src/adobe/DTMHandler.class')
const { SECTIONS_PATHS } = require('./lib/datalayer-paths')

/**
 * Specific DTMRule for BFG.
 */
class DTMRule extends SuperDTMRule {
  /**
   * Reset main Data Layer's eventInfo section,
   * before updating it with rule Data Layer.
   * Then clean its sections.
   * @override
   * @returns {DTMRule}
   */
  updateDataLayer () {
    if (SuperDTMHandler.instance) {
      SuperDTMHandler.instance.dataLayer.set(SECTIONS_PATHS.EVENT_INFO, {})
      SuperDTMHandler.instance.dataLayer.merge(this.dataLayer)
      SuperDTMHandler.instance.cleanDataLayerSections()
    }
    return this
  }
}

module.exports = DTMRule



// WEBPACK FOOTER //
// ./lib/modules/dgad-analytics/src/adobe/DTMRule.class.js